import { Injectable, isDevMode } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppComponent } from '../app.component';
import { ActiveListService } from './active-list.service';

const API_LIST_ENDPOINT = '/list';
const API_ITEM_ENDPOINT = '/item';

@Injectable({ providedIn: 'root' })
export class ListService {
  constructor(private http: HttpClient, private activeList: ActiveListService) {}

  getList(): Observable<any> {
    const lid = this.activeList.getListId();
    return this.http.get(AppComponent.baseUrl + API_LIST_ENDPOINT + '/overview?list_id=' + lid + '&_=' + Date.now(), { responseType: 'text' });
  }

  getListOfShop(shop: string): Observable<any> {
    const lid = this.activeList.getListId();
    return this.http.get(AppComponent.baseUrl + API_LIST_ENDPOINT + '/listofshop/' + encodeURIComponent(shop) + '?list_id=' + lid, { responseType: 'text' });
  }

  postData(input: any): Observable<any> {
    const lid = this.activeList.getListId();
    const body = { ids: input, list_id: lid };
    return this.http.post(AppComponent.baseUrl + API_LIST_ENDPOINT + '/postdata', JSON.stringify(body), { responseType: 'text' });
  }
  postNewitem(input: any): Observable<any> {
    const body = { ...input, list_id: this.activeList.getListId() };
    return this.http.post(AppComponent.baseUrl + API_ITEM_ENDPOINT + '/newitem', body, { responseType: 'text' });
  }
  removeItem(input : any):  Observable<any> {
	  return this.http.post(AppComponent.baseUrl+ API_ITEM_ENDPOINT+ '/removeitem', input , { responseType: 'text'});
    }
    removeItems(input : any):  Observable<any> {

      return this.http.post(AppComponent.baseUrl+ API_ITEM_ENDPOINT+ '/removeitems', JSON.stringify(input) , { responseType: 'text'});
      }
  updateItem(id: number, input: { name: string; shop: string }): Observable<any> {
      return this.http.post(AppComponent.baseUrl + API_ITEM_ENDPOINT + '/updateitem/' + id, input, { responseType: 'text' });
  }



}
